exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subitem-wrapper[data-v-a4786090] {\n&::before,\n    &::after {\n        margin: auto;\n        content: '';\n}\n}\n", ""]);

// exports
